import { useMemo } from 'react';
import { logger } from '@zep/core-logger';
import { cn } from '@zep/utils';
import { ProductSectionContent } from './ProductSectionContent';
import { ProductSectionHeader } from './ProductSectionHeader';
import { LandingProductProps, ProductButton } from './types';
const trackServiceClick = (serviceId: string) => {
  logger.track('landing_service_click', {
    section_name: 'product',
    service_name: serviceId
  });
};
const trackPricingClick = (serviceId: string) => {
  logger.track('landing_pricing_click', {
    service_name: serviceId
  });
};
export const LandingProduct = ({
  data,
  className
}: LandingProductProps) => {
  const primaryButtonWithTracking: ProductButton = useMemo(() => ({
    ...data.primaryButton,
    onClick: () => trackServiceClick(data.id)
  }), [data.primaryButton, data.id]);
  const secondaryButtonWithTracking: ProductButton = useMemo(() => ({
    ...data.secondaryButton,
    onClick: () => trackPricingClick(data.id)
  }), [data.secondaryButton, data.id]);
  return <section data-bg-section={data.id} className={cn('w-full', 'lg:py-quiz-lg', 'px-quiz-md tablet:px-quiz-lg lg:px-quiz-2xl', 'flex flex-col items-center justify-center', className)} data-sentry-component="LandingProduct" data-sentry-source-file="LandingProduct.tsx">
      <div className="flex w-full max-w-screen-xl flex-col gap-quiz-lg py-quiz-3xl tablet:py-quiz-4xl lg:gap-quiz-3xl">
        <ProductSectionHeader logo={data.logo} headerText={data.headerText} primaryButton={primaryButtonWithTracking} secondaryButton={secondaryButtonWithTracking} theme={data.theme} data-sentry-element="ProductSectionHeader" data-sentry-source-file="LandingProduct.tsx" />
        <ProductSectionContent descriptions={data.descriptions} theme={data.theme} data-sentry-element="ProductSectionContent" data-sentry-source-file="LandingProduct.tsx" />
      </div>
    </section>;
};